<template>
  <div class="main" :class="{ 'main--fix-footer': isFixed }">
    <!-- 进度条 -->
    <progress-bar v-if="showPro" :type="1" :current="current" class="bar"></progress-bar>

    <div class="container" :class="{ 'container--fix-footer': isFixed }">
      <van-form
        @submit="handleNext"
        @failed="onFail"
        :scroll-to-error="true"
        class="layout-form"
        :class="{ 'layout-form--fix-footer': isFixed }"
      >
        <div class="layout-form-body" :class="{ 'layout-form-body--fix-footer': isFixed }">
          <!-- 默认插槽 -->
          <slot></slot>
          <!-- 下一步按钮 -->
          <div :class="['footer-btns', { 'footer-btns--fixed': isFixed }]" v-show="nextBtnShow">
            <van-button plain size="small" class="btn-preview" v-show="preBtnShow" @click="handlePre">上一步</van-button>
            <van-button
              :disabled="isCannext"
              :class="`btn-next ${isCannext ? 'disabled' : ''}`"
              size="small"
              native-type="submit"
              type="primary"
              >{{ btnText }}</van-button
            >
          </div>
        </div>
      </van-form>
    </div>
  </div>
</template>

<script>
import { computed, defineComponent } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import scrollView from '@/utils/scroll-view'
import useOpenInfo from '@/hooks/openInfo'

export default defineComponent({
  name: 'Layout',
  props: {
    nextBtnShow: {
      type: Boolean,
      default: true
    },
    preBtnShow: {
      type: Boolean,
      default: true
    },
    showPro: {
      type: Boolean,
      default: true
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    fixFooter: {
      type: Boolean,
      default: false
    },
    current: {
      type: Number,
      default: 0
    },
    btnText: {
      type: String,
      default: '下一步'
    },
    form: {
      type: Object,
      default: () => ({})
    },
    prePathName: {
      type: String,
      default: ''
    }
  },
  setup (props, { emit }) {
    // const isClicked = ref(false);
    const { saveOpenInfoOfVuex } = useOpenInfo()
    const onFail = val => {
      console.log(val)
      scrollView()
    }
    const handleNext = val => {
      console.log(val)
      // 防止多次点击
      // if (isClicked.value) return;
      // isClicked.value = true;
      emit('handleNext')
    }
    const router = useRouter()
    const route = useRoute()
    const handlePre = () => {
      // router.go(-1);
      router.push({ name: props.prePathName })
      // emit('handlePre');
      saveOpenInfoOfVuex({ info: props.form })
    }
    const isCannext = computed(() => props.isDisabled)
    const isFixed = computed(
      () =>
        props.fixFooter ||
        route.name === 'online-cn' ||
        route.name === 'online-hk' ||
        route.name === 'captcha' ||
        route.name === 'transfer-step'
    )
    return {
      handleNext,
      route,
      isCannext,
      handlePre,
      onFail,
      isFixed
    }
  }
})
</script>

<style lang="scss" scoped>
.main--fix-footer {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 100%;
  height: 100%;
}

.container {
  padding: 0 15px;

  &--fix-footer {
    flex: 1;
    display: flex;
    flex-direction: column;
    min-height: 0;
  }
}

:deep(.layout-form--fix-footer) {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.layout-form-body {
  &--fix-footer {
    flex: 1;
    display: flex;
    flex-direction: column;
    min-height: 0;
  }
}

.disabled {
  background-color: #363d56;
  opacity: 0.9;
  color: #161617;
}

.footer-btns {
  display: flex;
  padding: 25px 10px;

  &--fixed {
    margin-top: auto;
    flex-shrink: 0;
    background-color: $bg-color;
    padding-bottom: calc(25px + env(safe-area-inset-bottom, 0px));
  }

  .btn-preview {
    width: 120px;
    color: #c8cfd9;
    border: 1px solid #959db7;
    border-radius: 8px;
    margin-right: 15px;
  }

  .btn-next {
    flex: 1;
  }

  button {
    height: 35px;
    border-radius: 8px;
  }
}
</style>
